import useLoggedUser from 'hooks/useLoggedUser';
import useServerDown from 'hooks/useServerDown';
import { UsersTypes } from 'types/global';
import { fetchDailyCodes } from 'lib/models/access';
import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { setDailyCodeList } from 'store/reducers/dailyCodes';
import useStoreDispatch from 'store/useStoreDispatch';

function DailyCodesLoader() {
	const location = useLocation();
	const dispatch = useStoreDispatch();
	const serverIsDown = useServerDown();
	// An NFC admin cannot read the parking codes, and has nothing to use them for
	const skip = useLoggedUser()?.type === UsersTypes.nfcAdmin;
	useEffect(() => {
		const fetchData = async () => {
			try {
				if (!serverIsDown && !skip) {
					const response = await fetchDailyCodes();

					if (!response) throw new Error('Network error');

					dispatch(setDailyCodeList(response));
				}
			} catch (error) {
				console.error(error);
			}
		};

		fetchData();
	}, [dispatch, serverIsDown, skip, location.pathname]);
	return <></>;
}

export default DailyCodesLoader;
